import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type RetryJobSourcingPayload = ApiRequestBody<
  typeof endpoints.jobSourceRetry,
  'post'
> & {
  jobId: string;
};

export const useRetryJobSourcingMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, ...body }: RetryJobSourcingPayload) => {
      return fetchClient.POST(endpoints.jobSourceRetry, {
        params: { path: { id: jobId } },
        body,
      });
    },
    onSettled: (_data, _error, variables) => {
      invalidateQuery(jobsQueryKeys.lists())();
      invalidateQuery(jobsQueryKeys.detail(variables.jobId))();
    },
  });
};
